export default "images/suite.jpg";